import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import IconRight from '../IconRight';

import styles from './index.scss';

const showResultsClasses = classNames({
    [styles.showResultsContainer]: true,
    'analytics-show-all': true,
});
const ShowResultsBar = ({ redirectTo, translationsMap }) => (
    <div className={showResultsClasses} onClick={redirectTo}>
        <div className={styles.showResults}>
            <div className={styles.showResults__text}>
                {translationsMap['search.fss.label.showAllResults']}
                <span className={styles.showResults__icon}>
                    <IconRight />
                </span>
            </div>
        </div>
    </div>
);

ShowResultsBar.propTypes = {
    redirectTo: PropTypes.func.isRequired,
};

ShowResultsBar.propTypes = {
    redirectTo: PropTypes.func.isRequired,
    translationsMap: PropTypes.object.isRequired,
};

export default ShowResultsBar;
